








































import { PartyProductModel } from '@/libs/Api';
import { Guid } from '@/libs/common/functions/guid';
import {Component, Vue, Prop, Ref} from 'vue-property-decorator';
import ClientInvestmentDialog from '@/libs/account/components/ClientInvestmentDialog.vue';
import RequestForQuotationDialog from '@/libs/account/components/RequestForQuotationDialog.vue';

@Component({
    components: {
        ClientInvestmentDialog,
        RequestForQuotationDialog
    }
})
export default class ClientInvestmentCard extends Vue {


    @Prop() partyProduct!: PartyProductModel;
    @Prop() clientId!: string;
    @Ref() dialog!: ClientInvestmentDialog;
    
    newId: string | null = Guid.EmptyGuid();

    openPartyProduct() {
        if (this.partyProduct.id == this.newId)
            return;
        this.dialog.open();
    }

}

